import { defineStore } from 'pinia'
import { authModule } from '@/store'
import IrmaoService from '@/services/IrmaoService'
import { queryClient } from '@/plugins/tanstack'
import { Novidade } from 'common/types/Novidade'
import Irmao from 'common/types/Irmao'

const NOVIDADES_STORAGE = 'novidades'

export const useApplicationStore = defineStore('application', {
	state: () => ({
		timer: null as number | null,
		novidade: null as Novidade | null,
	}),

	actions: {
		setTimer(timer: number | null) {
			this.timer = timer
		},

		setNovidades(novidade: Novidade) {
			window.localStorage[NOVIDADES_STORAGE] = JSON.stringify(novidade)
			this.novidade = novidade
		},

		async visualizar(visualizacoes: Partial<Pick<Irmao, 'ultVisualizacaoDeCandidatos' | 'ultVisualizacaoDeServicos'>>) {
			if (authModule.éVisitante) return

			const novidade: Novidade = {
				novosCandidatos: (visualizacoes.ultVisualizacaoDeCandidatos || !this.novidade) ? 0 : this.novidade.novosCandidatos,
				novosServicos: (visualizacoes.ultVisualizacaoDeServicos || !this.novidade) ? 0 : this.novidade.novosServicos,
			}
			this.setNovidades(novidade)

			if (!authModule.idUsuario) return

			queryClient.setQueryData(['novidades'], (): Novidade | void => {
				return novidade
			})

			return IrmaoService
				.patch(authModule.idUsuario, {
					ultVisualizacaoDeCandidatos: visualizacoes.ultVisualizacaoDeCandidatos,
					ultVisualizacaoDeServicos: visualizacoes.ultVisualizacaoDeServicos,
				})
				.catch(error => {
					// tslint:disable-next-line: no-console
					console.log('Atualizar Visualizações :>> ', error)
				})
		},

		async atualizarContexto() {
			if (authModule.éVisitante) return
			try {
				const novidade = await IrmaoService.novidades()
				this.setNovidades(novidade)
			} catch (error) {
				// tslint:disable-next-line: no-console
				console.log('Atualizar Contexto da Aplicação :>> ', error)
			}
		},

		async inicializarAtualizacaoDeContexto() {
			if (this.timer !== null) window.clearInterval(this.timer)

			const INTERVALO = 1000 * 60 * 60 // 1 hora
			const timer = (window.setInterval as any)(() => {
				this.atualizarContexto()
			}, INTERVALO)
			this.setTimer(timer as number)
			await this.atualizarContexto()
		},

		async pausarAtualizacaoDeContexto() {
			if (this.timer) window.clearInterval(this.timer)
		},
	},

	getters: {
		temNovidades(): boolean {
			return this.novidade ? Object.values(this.novidade).some((value) => value > 0) : false
		},
	},
})
